import React from 'react';
import Dashboard from './components/Dashboard';
import './styles.css';

function App() {
  return <Dashboard />;
}

export default App;
